// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"80":"TaxHisotry","216":"indexPage"}[chunkId] + "." + {"80":"f242f137","216":"6de7cafb"}[chunkId] + ".css";
};